import React from 'react'
import { Text } from '@components/UI'

export const Shortcut = ({ meta, hint }) => (
  <div className='shortcut'>
    <span className='meta'>{meta}</span>
    {hint && <Text>+ {hint}</Text>}
  </div>
)
